import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

const initialState = {
  data: null,
  page: 0,
  states:null,
  finish:null,
  status:'',
  errors:'',
  doc_image: null,
  currentId: 0,
};

const actionTypes = {
  set_data: "set_data",
  set_page: "set_page",
  set_states: "set_states",
  set_finish: "set_finish",
  set_status: "set_status",
  set_doc_image: "set_doc_image",
  set_errors: "set_errors",
  set_currentId: "set_currentId"
};
const persistConfig = {
  key: "formgntech", // Chave para identificar a raiz do estado persistido
  storage: storageSession, // Armazenamento local ou de sessão
  expires: 24 * 60 * 60 * 1000,
};
function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.set_data:
      console.log(action)
      return { ...state, data: {...state.data, ...action.payload}};
    case actionTypes.set_page:
      return { ...state, page: action.payload };
    case actionTypes.set_states:
      return { ...state, states: action.payload };
    case actionTypes.set_doc_image:
      return { ...state, doc_image: action.payload};
    case actionTypes.set_finish:
      return { ...state, finish: action.payload};
    case actionTypes.set_status:
      return { ...state, status: action.payload};
    case actionTypes.set_errors:
      return { ...state, errors: action.payload};
    case actionTypes.set_currentId:
      return { ...state, currentId: action.payload};
    default:
      return state;
  }
}

const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor, actionTypes };
